/**
 * fiscalYear năm tài chính
 * Mặc định ngày bắt đầu là thứ 2
 */

import { MSEnum } from '@/common/enumeration';
import moment from 'moment';
//Import thủ công locale tiếng Việt — các locale khác đã bị IgnorePlugin loại khỏi bundle (xem vue.config.js)
import 'moment/locale/vi';
moment.locale('vi');
let Period = MSEnum.Period;

class DateRange {
	constructor() { }

	/**
	 * Xác định quý
	 * @param {*} month
	 */
	caculQuarterByMonth(month) {
		// Xác định quý
		if (isNaN(month)) return;
		return Math.floor(month / 3) + 1;
	}

	/**
	 * Ngày hiện tại
	 */
	getThisDay() {
		return moment().startOf('day').toDate();
	}

	/**
	 * Tính ngày bắt đầu của tháng (1...12)
	 */
	getFromDateMonth(month) {
		return moment().month(month - 1).startOf('month').toDate();
	}

	/**
	 * Tính ngày kết thúc của tháng (1....12)
	 */
	getToDateMonth(month) {
		return moment().month(month - 1).endOf('month').toDate();
	}

	/**
	 * Quý này
	 */
	getThisQuarter() {
		return {
			fromDate: moment().startOf('quarter').toDate(),
			toDate: moment().endOf('quarter').toDate()
		};
	}

	/**
	 * Quý sau
	 */
	getNextQuarter() {
		return {
			fromDate: moment().add(1, 'quarter').startOf('quarter').toDate(),
			toDate: moment().add(1, 'quarter').endOf('quarter').toDate()
		};
	}

	/**
	 * Quý trước
	 */
	getLastQuarter() {
		return {
			fromDate: moment().subtract(1, 'quarter').startOf('quarter').toDate(),
			toDate: moment().subtract(1, 'quarter').endOf('quarter').toDate()
		};
	}

	/**
	 * Tính hôm qua
	 */
	getYesterday() {
		return moment().subtract(1, 'day').startOf('day').toDate();
	}

	/**
	 * Tính ngày mai
	 */
	getTomorrow() {
		return moment().add(1, 'day').startOf('day').toDate();
	}

	/**
	 * Tính tuần này
	 */
	getThisWeek() {
		return {
			fromDate: moment().startOf('isoWeek').toDate(),
			toDate: moment().endOf('isoWeek').toDate()
		};
	}

	/**
	 * Tính tuần trước
	 */
	getLastWeek() {
		return {
			fromDate: moment().subtract(1, 'weeks').startOf('isoWeek').toDate(),
			toDate: moment().subtract(1, 'weeks').endOf('isoWeek').toDate()
		};
	}

	// 30 ngày gần nhất
	getLast30Days() {
		return {
			fromDate: moment().subtract(29, 'days').startOf('day').toDate(),
			toDate: moment().endOf('day').toDate(),
		};
	}

	/**
	 * Tuần tới
	 */
	getNextWeek() {
		return {
			fromDate: moment().add(1, 'weeks').startOf('isoWeek').toDate(),
			toDate: moment().add(1, 'weeks').endOf('isoWeek').toDate()
		};
	}

	/**
	 * Tháng này
	 */
	getThisMonth() {
		return {
			fromDate: moment().startOf('month').toDate(),
			toDate: moment().endOf('month').toDate()
		};
	}

	/**
	 * Tháng trước
	 */
	getLastMonth() {
		return {
			fromDate: moment().subtract(1, 'months').startOf('month').toDate(),
			toDate: moment().subtract(1, 'months').endOf('month').toDate()
		};
	}

	/**
	 * Tháng tới
	 */
	getNextMonth() {
		return {
			fromDate: moment().add(1, 'months').startOf('month').toDate(),
			toDate: moment().add(1, 'months').endOf('month').toDate()
		};
	}

	/**
	 * Tính sáu tháng cuối năm
	 */
	getSixLastMonth() {
		const currentYear = moment().year();
		const range = {
			fromDate: moment([currentYear, 6, 1]).startOf('month').toDate(),
			toDate: moment([currentYear, 11, 1]).endOf('month').toDate()
		};
		return range;
	}

	/**
	 * Tính sáu tháng đầu năm
	 */
	getSixFirstMonth() {
		const currentYear = moment().year();
		const range = {
			fromDate: moment([currentYear, 0, 1]).startOf('month').toDate(),
			toDate: moment([currentYear, 5, 1]).endOf('month').toDate()
		};
		return range;
	}

	/**
	 * Tính năm trước
	 */
	getLastYear() {
		const lastYear = moment().subtract(1, 'year').year();
		const range = {
			fromDate: moment([lastYear, 0, 1]).startOf('year').toDate(),
			toDate: moment([lastYear, 11, 31]).endOf('year').toDate()
		};
		return range;
	}

	/**
	 * Tính năm sau
	 */
	getNextYear() {
		const nextYear = moment().add(1, 'year').year();
		const range = {
			fromDate: moment([nextYear, 0, 1]).startOf('year').toDate(),
			toDate: moment([nextYear, 11, 31]).endOf('year').toDate()
		};
		return range;
	}

	/**
	 * Tính năm nay
	 */
	getThisYear() {
		const currentYear = moment().year();
		const range = {
			fromDate: moment([currentYear, 0, 1]).startOf('year').toDate(),
			toDate: moment([currentYear, 11, 31]).endOf('year').toDate()
		};
		return range;
	}

	/**
	 * Đầu tuần đến hiện tại
	 */
	getFirstWeekToPresent() {
		const range = {
			fromDate: moment().startOf('isoWeek').toDate(),
			toDate: moment().toDate()
		};
		return range;
	}

	/**
	 * Đầu quý đến hiện tại
	 */
	getFirstQuarterToPresent() {
		const range = {
			fromDate: moment().startOf('quarter').toDate(),
			toDate: moment().toDate()
		};
		return range;
	}

	/**
	 * Đầu tháng đến hiện tại
	 */
	getFirstMonthToPresent() {
		const range = {
			fromDate: moment().startOf('month').toDate(),
			toDate: moment().toDate()
		};
		return range;
	}

	/**
	 * Đầu năm đến hiện tại
	 */
	getFirstYearToPresent() {
		const range = {
			fromDate: moment().startOf('year').toDate(),
			toDate: moment().toDate()
		};
		return range;
	}

	/**
	 * Ngày bắt đầu của quý
	 * @param {*} quater=tên quý +offset
	 */
	fromQuarter(quater, year) {
		// Tính ngày bắt đầu quý sử dụng moment
		let month = (quater - 1) * 3;
		return moment([year, month]).startOf('month').toDate();
	}

	/**
	 * Ngày kết thúc Quý
	 * @param {*} quater=tên quý +offset:Ví dụ quý I nhưng ngày final lại là 1/4 => Thực tế là quý 2
	 */
	toQuarter(quater, year) {
		// Tính ngày kết thúc quý sử dụng moment
		let month = quater * 3 - 1;
		return moment([year, month]).endOf('month').toDate();
	}

	/***
	 * TThuyen Hàm tính Ngày tháng
	 * @return {Object} trả về range {fromDate: , toDate: }
	 */
	caculateRangeFromPeriod(period, innerFromDate, innerToDate) {
		let me = this,
			range,
			fromDate,
			toDate;
		switch (period) {
			case Period.January:
			case Period.February:
			case Period.March:
			case Period.April:
			case Period.May:
			case Period.June:
			case Period.July:
			case Period.August:
			case Period.September:
			case Period.October:
			case Period.November:
			case Period.December:
				fromDate = me.getFromDateMonth(period);
				toDate = me.getToDateMonth(period);
				break;
			case Period.FiscalI:
			case Period.FiscalII:
			case Period.FiscalIII:
			case Period.FiscalIV: {
				let offsetQuarter = me.caculQuarterByMonth(0) - 1,
					fiscal = period / 100 + offsetQuarter;
				fromDate = me.fromQuarter(fiscal, new Date().getFullYear());
				toDate = me.toQuarter(fiscal, new Date().getFullYear());
				break;
			}
			case Period.ThisDay:
				fromDate = toDate = me.getThisDay();
				// toDate = me.getThisDay();
				break;
			case Period.Yesterday: {
				fromDate = toDate = me.getYesterday();
				break;
			}
			case Period.Tomorrow: {
				fromDate = me.getTomorrow();
				toDate = me.getTomorrow();
				break;
			}
			case Period.ThisWeek: {
				range = me.getThisWeek();

				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.LastWeek: {
				range = me.getLastWeek();

				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.NextWeek: {
				range = me.getNextWeek();

				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.ThisMonth: {
				range = me.getThisMonth();

				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.LastMonth: {
				range = me.getLastMonth();

				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.NextMonth: {
				range = me.getNextMonth();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.ThisQuarter: {
				range = me.getThisQuarter();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.LastQuarter: {
				range = me.getLastQuarter();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.NextQuarter: {
				range = me.getNextQuarter();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.SixLastMonth: {
				range = me.getSixLastMonth();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.SixFirstMonth: {
				range = me.getSixFirstMonth();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.ThisYear: {
				range = me.getThisYear();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.LastYear: {
				range = me.getLastYear();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.NextYear: {
				range = me.getNextYear();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			// case Period.ThreeLastYear: {
			// 	range = me.getThreeLastWeek();
			// 	fromDate = range.fromDate;
			// 	toDate = range.toDate;
			// 	break;
			// }
			case Period.FirstWeekToPresent: {
				range = me.getFirstWeekToPresent();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.FirstQuarterToPresent: {
				range = me.getFirstQuarterToPresent();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.FirstYearToPresent: {
				range = me.getFirstYearToPresent();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.FirstMonthToPresent: {
				range = me.getFirstMonthToPresent();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.Last7Day: {
				let nowFromDate = me.getThisDay();
				let nowToDate = me.getThisDay();
				toDate = nowToDate;
				fromDate = nowFromDate.addDays(-6);
				break;
			}
			case Period.Last30Days: {
				range = me.getLast30Days();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			default:
				fromDate = innerFromDate;
				toDate = innerToDate;
				break;
		}

		return {
			fromDate: fromDate,
			toDate: toDate
		};
	}

	/**
	 * Tính ra kỳ theo từ ngày và đến ngày
	 * @param {Date} fromDate Từ ngày
	 * @param {Date} toDate Đến ngày
	 * @returns {number} Giá trị của kỳ (theo MSEnum)
	 * @author pcminh 24.04.2020
	 */
	caculatePeriodFromRange(fromDate, toDate) {
		let period = MSEnum.Period.Custom;
		for (let i = 0; i < Object.keys(MSEnum.Period).length; i++) {
			const key = Object.keys(MSEnum.Period)[i];
			let range = this.caculateRangeFromPeriod(MSEnum.Period[key]);
			if (
				new Date(fromDate).toDateString() == new Date(range.fromDate).toDateString() &&
				new Date(toDate).toDateString() == new Date(range.toDate).toDateString()
			) {
				period = MSEnum.Period[key];
				break;
			}
		}
		return period;
	}
}

export default new DateRange();
